import React, {useState} from 'react';
import axios from "axios";
import { Container,  Card, CardText, CardBody,Alert,
  CardTitle, Button } from "reactstrap";
import { useLocation, Redirect } from "react-router-dom";

import './signUpSuccessfull.css';

const style = {
  height: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}


const API_URL = process.env.REACT_APP_API_URL_BASE;

const VerifyAccount = props => {
  const location = useLocation();
  const [redirect, setRedirect] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorText, setErrorText] = useState('');


  const handleVerification = (event) => {

    const path = location.pathname.split('/');
    const token = path[2];

    console.log("Path:", path);
    console.log("Token:", token);

    var payload={
      token: token
    };

    axios.post(`${API_URL}users/verify-account`, payload).then(response => {
      if(response.status === 200){
        setSuccess(true);
        setTimeout(() => setRedirect(true), 2000);
      } else{
        setErrorText('Something went wrong. Please try again.');
        setError(true);
        setTimeout(() => setRedirect(true), 5000);
      }
    })
    .catch(function (error) {
      setErrorText([[error.response.data.status]]);
      if (error.response) {
        if(error.response.status === 400)
        {
          let error_data = error.response.data;
          let error_msg = error_data.detail;

          if(error_msg) {
            setError(true);
            setErrorText(error_msg);
          }
          else
          {
            setError(true);
            setErrorText('Something went wrong. Please try again.');
          }
        }
        else {
          setError(true);
          setErrorText('Something went wrong. Please try again.');
        }
      } else if (error.request) {
        setError(true);
        setErrorText('Something went wrong. Please try again.');
      } else {
        setError(true);
        setErrorText('Something went wrong. Please try again.');
      }

      setTimeout(() => setRedirect(true), 5000);
    });
  }

  return (
    <Container className="bl-back-image" fluid={true} style={style}>
      <Card>
        <CardBody className="text-center">
          <CardTitle>
              <h1 className="text-center" style={{fontSize: '50px'}}>Just One More Step...</h1>
          </CardTitle>
          <CardText>
              <div className="text-center pl-2 pr-2" style={{fontSize: '20px', marginTop: '40px'}}>
                <p>
                    Please click on the button below to verify your account.
                </p>
              </div>

              <div className="mt-5">
                  <Button className="btn btn-lg" style={{fontSize: '25px'}} color="primary" onClick={handleVerification}>Verify</Button>
              </div>
          </CardText>
        </CardBody>
      <div style={{ padding: "0 20px" }}>
      {
        error && <Alert className="m-5" color="danger">{errorText}</Alert>
      }
      {success && (
          <Alert color="success">
            Your account has been verified! Please <b>return to the start page</b> and log in with your credentials.
          </Alert>
      )}
      {redirect ? <Redirect to="/authentication/login" /> : null}
      </div>
      </Card>
    </Container>
  );
};

export default VerifyAccount;
